module.exports = __webpack_public_path__ + "img/pro_four_3.a07d4d08.jpg";